module.exports = __webpack_public_path__ + "img/1212a_3.cf0f7e54.jpg";